export default {"src":"/_next/static/media/0x1bf74c010e6320bab11e2e5a532b5ac15e0b8aa6.82a638d4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};